/**
 * WordPress dependencies
 */
const { PanelBody, Placeholder, SelectControl, TextControl, TextareaControl, ToggleControl, ToolbarButton, Tooltip } = wp.components;
const { InspectorControls, BlockControls } = wp.hasOwnProperty( 'blockEditor' ) ? wp.blockEditor : wp.editor;
const { Component, Fragment } = wp.element;
const { __ } = wp.i18n;
const { addQueryArgs } = wp.url;

let { ServerSideRender } = wp.components;
if ( wp.hasOwnProperty( 'serverSideRender' ) ) {
	ServerSideRender = wp.serverSideRender;
}


/**
 * Internal dependencies
 */
import './block.scss';
import icon from './icon'

class Edit extends Component {

	constructor() {

		super( ...arguments );

		// Set initial state.
		this.state = { formWasDeleted: false };

		// Bind events.
		this.setFormId = this.setFormId.bind( this );

		// Get defined form ID.
		const { formId } = this.props.attributes;

		// If form has been selected, disable preview / reset.
		if ( formId ) {

			// Get form object.
			const form = Edit.getForm( formId );

			// If form was not found, reset block.
			if ( ! form ) {

				// Reset form ID.
				this.props.setAttributes( { formId: '' } );

				// Set failed state.
				this.state = { formWasDeleted: true };

			// If form was found and has conditional logic, disable preview.
			} else if ( form && form.hasConditionalLogic ) {
				this.props.setAttributes( { formPreview: false } );
			}

		}

	}

	componentWillUnmount() {

		this.unmounting = true;

	}

	setFormId( formId ) {

		let form = Edit.getForm( formId );

		this.props.setAttributes( { formId } );
		this.setState( { formWasDeleted: false } );

		if ( form && form.hasConditionalLogic ) {
			this.props.setAttributes( { formPreview: false } );
		}

	}

	static getForm( formId ) {

		return gform_block_form.forms.find( ( form ) => form.id == formId );

	}

	static getFormOptions() {

		let options = [
			{
				label: __( 'Select a Form', 'gravityforms' ),
				value: '',
			}
		];

		for ( let i = 0; i < gform_block_form.forms.length; i++ ) {

			let form = gform_block_form.forms[ i ];

			options.push( {
				label: form.title,
				value: form.id,
			} );

		}

		return options;

	}

	openAdminPage( e, params ) {
		e.preventDefault();

		const url = addQueryArgs( gform_block_form.adminURL, params );

		window.open( url, '_blank', 'noopener' );
	}

	externalControls() {
		let { formId } = this.props.attributes;

		if ( ! formId ) {
			return null;
		}

		const editParams = {
			page: 'gf_edit_forms',
			id: formId,
		};

		const settingsParams ={
			page: 'gf_edit_forms',
			id: formId,
			view: 'settings'
		};

		return (
			<BlockControls key="gform-block-custom-controls">
				<ToolbarButton
					key="gform-block-edit-form-buttton"
					title={ __( 'Edit Form', 'gravityforms' ) }
					onClick={(e) => { this.openAdminPage( e, editParams ) } }
					className="gform-block__toolbar-button"
				>
					<Tooltip text={ __( 'Edit Form', 'gravityforms' ) } >
						<i className="gform-icon gform-icon--create" />
					</Tooltip>
				</ToolbarButton>
				<ToolbarButton
					key="gform-block-form-settings-button"
					label={ __( 'Form Settings', 'gravityforms' ) }
					title={ __( 'Form Settings', 'gravityforms' ) }
					onClick={(e) => { this.openAdminPage( e, settingsParams ) } }
					className="gform-block__toolbar-button"
				>
					<Tooltip text={ __( 'Form Settings', 'gravityforms' ) }>
						<i className="gform-icon gform-icon--cog" />
					</Tooltip>
				</ToolbarButton>
			</BlockControls>
		);
	}

	render() {

		let { formId, title, description, ajax, tabindex, formPreview, fieldValues, imgPreview } = this.props.attributes;

		const { setAttributes, isSelected } = this.props;

		const toggleTitle = () => setAttributes( { title: ! title } );
		const toggleDescription = () => setAttributes( { description: ! description } );
		const toggleAjax = () => setAttributes( { ajax: ! ajax } );
		const toggleFormPreview = () => setAttributes( { formPreview: ! formPreview } );

		const updateTabindex = ( tabindex ) => setAttributes( { tabindex } );

		const setFormIdFromPlaceholder = ( e ) => this.setFormId( e.target.value );

		if ( imgPreview ) {
			return (
				<Fragment>
					<img src={ gform_block_form.preview } style={{margin:'0 auto', display:'block'}} />
				</Fragment>
			);
		}

		const controls = [
			this.externalControls(),
			isSelected && gform_block_form.forms && gform_block_form.forms.length > 0 && (
				<InspectorControls key="inspector">
					<PanelBody
						title={ __( 'Form Settings', 'gravityforms' ) }
					>
						<SelectControl
							label={ __( 'Form', 'gravityforms' ) }
							value={ formId }
							options={ Edit.getFormOptions() }
							onChange={ this.setFormId }
						/>
						{
							formId && <ToggleControl
								label={ __( 'Form Title', 'gravityforms' ) }
								checked={ title }
								onChange={ toggleTitle }
							/>
						}
						{
							formId && <ToggleControl
								label={ __( 'Form Description', 'gravityforms' ) }
								checked={ description }
								onChange={ toggleDescription }
							/>
						}
					</PanelBody>
					{
						formId && <PanelBody
							title={ __( 'Advanced', 'gravityforms' ) }
							initialOpen={ false }
							className="gform-block__panel"
						>
							{
								formId && ! Edit.getForm( formId ).hasConditionalLogic &&
								<ToggleControl
									label={ __( 'Preview', 'gravityforms' ) }
									checked={ formPreview }
									onChange={ toggleFormPreview }
								/>
							}
							<ToggleControl
								label={ __( 'AJAX', 'gravityforms' ) }
								checked={ ajax }
								onChange={ toggleAjax }
							/>
							<TextareaControl
								label={ __( 'Field Values', 'gravityforms' ) }
								value={ fieldValues }
								onChange={ ( fieldValues ) => { setAttributes( { fieldValues } ) } }
							/>
							<TextControl
								className="gform-block__tabindex"
								label={ __( 'Tabindex', 'gravityforms' ) }
								type="number"
								value={ tabindex }
								onChange={ updateTabindex }
								placeholder="-1"
							/>
							<Fragment>
								Form ID: { formId }
							</Fragment>
						</PanelBody>
					}
				</InspectorControls>
			),
		];

		if ( ! formId || ! formPreview ) {

			const { formWasDeleted } = this.state;

			return [
				controls,
				(
					formWasDeleted && <div className="gform-block__alert gform-block__alert-error">
						<p>{ __( 'The selected form has been deleted or trashed. Please select a new form.', 'gravityforms' ) }</p>
					</div>
				),
				<Placeholder key="placeholder" className="wp-block-embed gform-block__placeholder">
					<div className="gform-block__placeholder-brand">
						<div className={ 'gform-icon' }>{ icon }</div>
						<p><strong>Gravity Forms</strong></p>
					</div>
					{
						gform_block_form.forms && gform_block_form.forms.length > 0 &&
						<form>
							<select value={ formId } onChange={ setFormIdFromPlaceholder }>
								{ Edit.getFormOptions().map( form =>
									<option key={ form.value } value={ form.value }>{ form.label }</option>,
								) }
							</select>
						</form>
					}
					{
						( ( ! gform_block_form.forms ) || ( gform_block_form.forms && gform_block_form.forms.length === 0 ) ) &&
						<form><p>{ __( 'You must have at least one form to use the block.', 'gravityforms' ) }</p></form>
					}
				</Placeholder>
			];

		}

		return [
			controls,
			<ServerSideRender
				key="form_preview"
				block="gravityforms/form"
				attributes={ this.props.attributes }
			/>,
		];

	}

}

export default Edit
